import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

const initialState = {
  sidebarUnfoldable: true,
  sidebarShow: true,
}

// export const getSettingReq = createAsyncThunk(
//   'getSetting',
//   async (data, { rejectWithValue }) => {
//     try {
//       const res = await setting();
//       return res.data.data;
//     } catch (err) {
//       return handleError(err, rejectWithValue);
//     }
//   }
// );

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    toggleSidebar: (state, action) => {
      state.sidebarShow = action.payload
    },
    toggleFoldable: (state, action) => {
      state.sidebarUnfoldable = action.payload
    },
  },
  // extraReducers: (builder) => {
  //   builder

  //     .addCase(getSettingReq.fulfilled, (state, action) => {
  //       state.setting = action.payload;
  //     })

  // },
})

export const { toggleFoldable, toggleSidebar } = appSlice.actions

export default appSlice.reducer
